import React, { Component } from "react";
import { DynamicFormFieldProps } from "../DynamicForm";
import { DynamicFormField, DynamicFormValidation } from "../../laco-common/base/form-validation/dynamic";
import { ISelectFormField } from "../../laco-common";
import { WithOptional } from "../../laco-common/helpers/extendedTypes";
import ItemFormInput from "./ItemForm";
import { IQuote, QuotesCollection } from "../../models/quote";
import "./Quote.scss";

const getFields = (
	data: IQuote
): Record<keyof IQuote, DynamicFormField & WithOptional<Partial<ISelectFormField>, "id" | "fieldType">> => {
	return {
		content: { order: 0, value: data?.content, label: "Content", fieldType: "textarea" },
		by: {
			order: 10,
			value: data?.by,
			label: "By",
			fieldType: "text",
			optional: true,
		},
		location: {
			order: 20,
			value: data?.location,
			label: "Assignment",
			fieldType: "text",
			optional: true,
		},
		profileImg: {
			order: 30,
			value: data?.profileImg,
			label: "Profile Image",
			fieldType: "imageUrl",
			optional: true,
		},
	};
};

type QuoteInputState = {
	quotes: IQuote[];
	refresh: number;
};

export default class QuoteInput extends Component<DynamicFormFieldProps & QuotesCollection, QuoteInputState> {
	state = {
		quotes: [],
		refresh: 0,
	};

	componentDidMount() {
		console.log("QuoteInput.componentDidMount(): props", this.props);
		this.setState({ quotes: this.getQuotes(), refresh: this.state.refresh + 1 });
	}

	getQuotes(): IQuote[] {
		const quotes: IQuote[] = [];
		(this.props.quotes || []).forEach((q: string, i: number) => {
			quotes.push({
				content: q,
				by: (this.props.quoters || [])[i] || "",
				profileImg: (this.props.profileImages || [])[i] || "",
				location: (this.props.locations || [])[i] || "",
			});
		});
		return quotes;
	}

	onQuoteFormChange(field: keyof IQuote, form: DynamicFormValidation, i: number) {
		console.log("Quote onFormChange(): field, index, form:", field, i, form);
		const updatedArr: IQuote[] = [...this.state.quotes];
		updatedArr[i][field] = form.fields[field].value;
		console.log("updatedQuotesArr:", updatedArr);
		let fieldName: keyof QuotesCollection;
		switch (field) {
			case "content":
				fieldName = "quotes";
				break;
			case "by":
				fieldName = "quoters";
				break;
			case "location":
				fieldName = "locations";
				break;
			case "profileImg":
				fieldName = "profileImages";
				break;
		}
		this.props.onChange(
			fieldName,
			updatedArr.map((q: IQuote) => q[field])
		);
	}

	onAddDelete(quotes: IQuote[]) {
		console.log("onAddDelete(): quotes:", quotes);
		this.setState({ quotes });
		this.props.onChange(
			"quotes",
			quotes.map((q: IQuote) => q.content)
		);
		this.props.onChange(
			"quoters",
			quotes.map((q: IQuote) => q.by)
		);
		this.props.onChange(
			"profileImages",
			quotes.map((q: IQuote) => q.profileImg)
		);
		this.props.onChange(
			"location",
			quotes.map((q: IQuote) => q.location)
		);
	}

	render() {
		const { field, onChange, ...other } = this.props;

		return (
			<ItemFormInput
				key={this.state.refresh}
				{...other}
				field={{ ...field, value: this.state.quotes }}
				itemName="Quote"
				nameField={undefined}
				viewItemSelector=".swipable-content"
				itemClassName="quote-item"
				getFields={getFields}
				createNew={() => {
					return { content: "Sample quote", by: "John Doe" };
				}}
				onChange={this.onAddDelete.bind(this)}
				onFormChange={this.onQuoteFormChange.bind(this)}
			/>
		);
	}
}
